// extracted by mini-css-extract-plugin
export default {"value":"styles_value__qBISs","sliderWrapper":"styles_sliderWrapper__1V2qJ","track":"styles_track__6ZpGW","range":"styles_range__79vwT","thumb":"styles_thumb__aJu0z"};